
import { Component, OnInit, Output, Input, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { GlobalService } from 'src/app/services/global.service';
import { Subject, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-form-select-box',
  templateUrl: './form-select-box.component.html',
  styleUrls: ['./form-select-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})

export class FormSelectBoxComponent implements OnInit {
  @Input() options: any;
  @Input() specialArray: any;
  @Input() currentSelectedValue: any;
  @Input('dropdownLabel') dropdownLabel: any;
  @Input() id: any;
  @Input() index: any;
  @Input() controlName: any;
  @Input() isAllOptionShow: boolean = false;
  @Input() isDefaultOptionShow: boolean = false;
  @Input() isDefaultOptionShowHidden:string='';
  @Input('dropDownIdKey') dropDownIdKey: any;
  @Input() formElementName: FormGroup;
  @Input() addCurrentSelectedValue: any;
  @Input() selected: any;
  @Output() currentSelectionChange = new EventEmitter<object>();
  public newOption: string;
  public emptyDataSelection: string = 'Select';
  public _id: string = 'Select';
  public _controlName: any;
  public _selected: any = "";
  public _currentSelection: string = '';
  public showDropDown: boolean = false;
  public previousOptions: Array<any> = [];
  public selectOptions: Array<any> = [];
  public _selectOptions: Array<any> = [];
  public _specialArray: Array<any> = [];
  public specialDataArray: Array<any> = [];
  public searchTerm$ = new Subject<Object>();

  constructor(public globalService: GlobalService, private formBuilder: FormBuilder, public cd: ChangeDetectorRef) {
    this.newOption = '';
    var self = this;
    this.detectOutsideClicks(self);
    this.searchMethod(this.searchTerm$)
      .subscribe(results => {
        if (results['value']) {
          if (this._specialArray && this._specialArray.length > 0) {
            let arr = [];
            let newArr = [];
            for (let index = 0; index < this._specialArray.length; index++) {
              const element = this._specialArray[index];
              arr.push({ name: element['name'], arrayList: [] });
              for (let i = 0; i < element['arrayList'].length; i++) {
                const ele = element['arrayList'][i];
                if (ele['name'].toLowerCase().indexOf(results['value'].toString().toLowerCase()) > -1) {
                  arr[index]['arrayList'].push(ele);
                }
              }
              if (arr[index]['arrayList'].length > 0) {
                if (!newArr.some((el) => el['name'] == arr[index]['name']))
                  newArr.push(arr[index]);
              }
            }
            this.specialDataArray = newArr;
          } else {
            this.selectOptions = this._selectOptions.filter(el => el['name'].toLowerCase().indexOf(results['value'].toString().toLowerCase()) > -1);
          }
        } else {
          if (this._specialArray && this._specialArray.length > 0) {
            this.specialDataArray = this._specialArray;
          } else this.selectOptions = this._selectOptions;
        }
      });
  }

  //find parent by class name
  findParentByClass(node, cls) {
    while (node && !this.hasClass(node, cls)) {
      node = node.parentNode;
    }
    return node;
  }
  searchMethod(terms: Observable<Object>) {
    return terms.pipe(debounceTime(400),
      distinctUntilChanged());
  }

  // inputClicked() {
  //   let col = document.getElementsByClassName('cp-dropdown__select');
  //   if (col) {
  //     Array.prototype.forEach.call(col, function (el) {
  //       el ? el.parentNode.removeChild(el) : '';
  //     });
  //   }
  //   // this.cd.detectChanges();
  //   // setTimeout(() => {
  //   this.showDropDown = !this.showDropDown;

  //   // }, 0);
  // }
  //check it has class
  hasClass(elem, cls) {
    var str = " " + elem.className + " ";
    var testCls = " " + cls + " ";
    return (str.indexOf(testCls) !== -1);
  }

  // close select options in outside click on window
  private detectOutsideClicks(self: this) {
    var self = this;
    if (this.globalService.isBrowser) {
      document.body.addEventListener('click', function (event: any) {
        if (!event.path.some(el => el['id'] == "select-div")) {
          if (!self.findParentByClass(event.target, "select-input-wrapper")) {
            if (self.showDropDown === true)
              self.showDropDown = false;
          }
        }
      });
    }
  }

  ngOnInit() {
  }

  ngDoCheck() {
    if (this.isDefaultOptionShow)
      this.emptyDataSelection = 'Default';
    if (this.controlName && this.controlName != this._controlName)
      this._controlName = this.controlName;

    if (this.id != this._id)
      this._id = this.id;
    //  this.enableDisable();
    if (this.options != this.previousOptions) {
      this.selectOptions = [];
      this._selectOptions = [];
      this.specialDataArray = [];
      this._specialArray = [];
      if (this.currentSelectedValue)
        this._currentSelection = this.currentSelectedValue;
      if (this.specialArray)
        this._specialArray = JSON.parse(JSON.stringify(this.specialArray));

      this.previousOptions = this.options;
      if (this.options && this.options.length > 0) {
        this.options.forEach(element => {
          if (this.addCurrentSelectedValue) {
            this.selectOptions.push({ name: this._currentSelection.split(' ')[0] + ' ' + element[this.dropdownLabel], link: element['link'], cardType: element['cardType'], type: element['type'], id: element[this.dropDownIdKey] });
            this._selectOptions.push({ name: this._currentSelection.split(' ')[0] + ' ' + element[this.dropdownLabel], link: element['link'], cardType: element['cardType'], type: element['type'], id: element[this.dropDownIdKey] });

          }
          else {
            this.selectOptions.push({ name: element[this.dropdownLabel], type: element['type'], link: element['link'], cardType: element['cardType'], id: element[this.dropDownIdKey] });
            this._selectOptions.push({ name: element[this.dropdownLabel], type: element['type'], link: element['link'], cardType: element['cardType'], id: element[this.dropDownIdKey] });

          }
          this.enableDisable();

        });
      }
      if (this.specialArray && this.specialArray.length > 0) {
        this.specialArray.forEach(element => {
          if (this.addCurrentSelectedValue) {
            this.specialDataArray.push({ name: element['name'], arrayList: element['arrayList'] });
            this._specialArray.push({ name: element['name'], arrayList: element['arrayList'] });
          }
          else {
            this.specialDataArray.push({ name: element['name'], arrayList: element['arrayList'] });
            this._specialArray.push({ name: element['name'], arrayList: element['arrayList'] });

          }
          this.enableDisable();

        });
      }

    }
    if (this.selected && this.selected != this._selected) {
      this._selected = this.selected;
      if (this.selectOptions && this.selectOptions.length > 0) {
          for (let index = 0; index < this.selectOptions.length; index++) {
            const element = this.selectOptions[index];
            if (this._selected.toLowerCase() == element['id'].toLowerCase()) {
              this._currentSelection = element['name'];
            }
          }
      }
    }
  }

  enableDisable() {
    // if(this.selectOptions.length==0){
    //   document.getElementById(this._id)?document.getElementById(this._id).classList.add("partial-disable"):"";
    // }else{
    //   document.getElementById(this._id)?document.getElementById(this._id).classList.remove("disabled"):"";
    // }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.currentSelectedValue) {
        this._currentSelection = this.currentSelectedValue;
      }
      this.enableDisable();
    }, 0);
  }

  public previousEVentTime: number = 0;
  public triggerDropDown(event: any, type: boolean): void {
    if (!type) {
      if (this.showDropDown && event && event['type'] == "focus")
        return;
      else {
      }
    } else {
      if (this.showDropDown && event && event['type'] == "click")
        return;
    }
    if (((this.globalService.autoCompleteArray == this._selectOptions) || (this.globalService.autoCompleteArray == this._specialArray)) && this.showDropDown == true) {
      if ((new Date().getTime() - this.previousEVentTime) > 400)
        this.showDropDown = false;
    }
    else {
      this.previousEVentTime = new Date().getTime();
      let inter = setInterval(() => {
        let $ul = document.getElementById('select-options');
        let el = document.getElementsByClassName('tabbing-content-wrapper')[0];
        let $button = document.getElementById(this._id);
        if ($ul) {
          clearInterval(inter);
          $ul.classList.remove("dropup");

          var newVar: any = this.findParentByClass($ul, 'form-field');
          if (newVar) {
            let test = newVar.getBoundingClientRect()['top'] - 160;
            let spaceUp = (test - $button.getBoundingClientRect()['height'] -
              $ul.getBoundingClientRect()['height']) - el.scrollTop;

            //   // how much space is left at the bottom
            let spaceDown = el.scrollTop + el.clientHeight - (test + $ul.getBoundingClientRect()['height']);
            // switch to dropup only if there is no space at the bottom AND there is space at the top, or there isn't either but it would be still better fit
            if (spaceDown < 0 && (spaceUp >= 0 || spaceUp > spaceDown)) {

              $ul.classList.add("dropup");
            }
            this.showDropDown = true;

          }
        } else
          this.showDropDown = true;

      }, 100);
      if (this._specialArray && this._specialArray.length > 0)
        this.globalService.autoCompleteArray = this._specialArray;
      else {
        this.globalService.autoCompleteArray = this._selectOptions;

      }
    }
  }

  get currentSelection(): any {
    return this._currentSelection;
  }

  //set the selected option
  public setCurrentSelection(option): void {
    this.showDropDown = false;
    this._currentSelection = option['name'];
    option['fieldName'] = this._controlName ? this._controlName.substr(0, (this._controlName.length - 12)) : '';
    option['index'] = this.index;
    this.currentSelectionChange.emit(option);
  }
}
